var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisseddose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_16556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7951 17.2051L21.5146 14.4856C22.3118 13.6997 22.9457 12.7639 23.3797 11.732C23.8136 10.7 24.0391 9.59244 24.0431 8.47299C24.0471 7.35354 23.8296 6.24436 23.4031 5.20934C22.9765 4.17433 22.3494 3.23395 21.5578 2.44238C20.7663 1.6508 19.8259 1.02368 18.7909 0.597137C17.7558 0.170596 16.6467 -0.046932 15.5272 -0.0429141C14.4078 -0.0388961 13.3002 0.186588 12.2683 0.620548C11.2363 1.05451 10.3005 1.68836 9.5146 2.4856L6.7951 5.2051L18.7951 17.2051ZM17.2051 18.7951L5.2051 6.7951L2.4856 9.5146C1.68836 10.3005 1.05451 11.2363 0.620548 12.2683C0.186588 13.3002 -0.0388961 14.4078 -0.0429141 15.5272C-0.046932 16.6467 0.170596 17.7558 0.597137 18.7909C1.02368 19.8259 1.6508 20.7663 2.44238 21.5578C3.23395 22.3494 4.17433 22.9765 5.20934 23.4031C6.24436 23.8296 7.35354 24.0471 8.47299 24.0431C9.59244 24.0391 10.7 23.8136 11.732 23.3797C12.7639 22.9457 13.6997 22.3118 14.4856 21.5146L17.2051 18.7951Z",
    fill: "#6D5FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_16556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisseddose);
export default __webpack_public_path__ + "static/media/misseddose.439158588f7b6620b725a784cd9591d5.svg";
export { ForwardRef as ReactComponent };